import DiscoveryPage from '../../features/discovery/DiscoveryPage';

export default function Discover() {
  return <DiscoveryPage />;
}
